// RIVVR curated content — swap these entries with your real assets when ready.
// Screenshots, audio files and the feature film all live in /frontend/public/media
// (or use any direct URL). Titles, artists and copy below are placeholders.

export const SCREENSHOTS = [
    "/media/app-real-home.jpg",
    "/media/app-real-fargo.jpg",
    "/media/app-real-wire.jpg",
    "/media/app-real-nowplaying.jpg",
    "/media/app-real-musichome.jpg",
    "/media/app-real-listeners.jpg",
    "/media/app-real-ariel2.jpg",
    "/media/app-real-tip.jpg",
    "/media/app-real-musictv.jpg",
    "/media/app-real-livetonight.jpg",
    "/media/app-real-liveshow.jpg",
    "/media/app-real-moviehome.jpg",
    "/media/app-real-beards.jpg",
    "/media/app-real-rocky.jpg",
    "/media/app-real-breakingbad.jpg",
    "/media/app-real-jaws.jpg",
    "/media/app-real-musicdiscover.jpg",
    "/media/app-real-radio.jpg",
    "/media/app-real-hannah.jpg",
    "/media/app-real-zeroes.jpg",
    "/media/app-real-dune.jpg",
    "/media/app-real-madmen.jpg",
    "/media/app-real-artistportal.jpg",
    "/media/app-real-originals.jpg",
];

export const TRACKS = [
    {
        id: "hannah-baby",
        title: "The Hour...that changed the world",
        artist: "Modiphyde",
        tag: "MP3 · HI-FI",
        // artwork: song/track cover (big card)
        art: "/media/modiphyde-fullscreen3.webp",
        // artistArt: artist portrait/avatar (list thumbs + artist chip)
        artistArt: "/media/modiphyde-artist-hero3.webp",
        src: "/media/hannah-baby.mp3",
    },
    {
        id: "nella-fantasia",
        title: "Nella Fantasia",
        artist: "Magnelli",
        tag: "AAC · HI-FI",
        art: "/media/nella-fantasia.jpg",
        artistArt: "/media/nella-fantasia.jpg",
        src: "/media/nella-fantasia.m4a",
        altSrc: "/media/nella-fantasia.mp3",
    },
    {
        id: "subterranean-frequencies",
        title: "Subterranean Frequencies",
        artist: "Kaelen Voss",
        tag: "DEEP CUT",
        art: "/media/subterranean-frequencies.jpg",
        artistArt:
            "https://images.unsplash.com/photo-1702259970719-fc3b6448de9b?crop=entropy&cs=srgb&fm=jpg&q=85",
        src: "/media/track-3.mp3",
    },
];

export const PHONE_MOVIES = [
    {
        id: "rocky",
        title: "Rocky",
        label: "Movies",
        meta: "Movie Greats",
        genre: "Drama",
        phoneArt: "/media/videos/rocky-phone.webp",
        thumb: "/media/videos/rocky-thumb.png",
        src: "/media/videos/rocky.mp4",
        description:
            "Descriptive text. Movie title, genre story synopsis, etc...",
    },
    {
        id: "fargo",
        title: "Fargo",
        label: "Series",
        meta: "TV Greats",
        genre: "Crime · Drama",
        phoneArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/b3b501f9071aa333_Fargo%20Series%20RIVVR%20preview.webp",
        thumb: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/6f165b77598c606a_Fargo%20Thubnail.png",
        src: "streamable://sh9x2y",
        description:
            "Descriptive text. Movie title, genre story synopsis, etc...",
    },
    {
        id: "jaws",
        title: "Jaws",
        label: "Movies",
        meta: "Movie Greats",
        genre: "Thriller",
        phoneArt: "/media/videos/jaws-phone.webp",
        thumb: "/media/videos/jaws-thumb.png",
        src: "/media/videos/jaws.mp4",
        description:
            "Descriptive text. Movie title, genre story synopsis, etc...",
    },
    {
        id: "behind-the-beards",
        title: "Behind the Beards and Bikes",
        label: "RIVVR Originals",
        meta: "RIVVR Originals",
        genre: "Docuseries",
        phoneArt: "/media/videos/beards-phone.webp",
        thumb: "/media/videos/beards-thumb.png",
        src: "/media/videos/beards.mp4",
        description:
            "Descriptive text. Movie title, genre story synopsis, etc...",
    },
    {
        id: "godfather",
        title: "The Godfather",
        label: "Movies",
        meta: "Movie Greats",
        genre: "Crime",
        phoneArt: "/media/videos/godfather-phone.webp",
        thumb: "/media/videos/godfather-thumb.png",
        src: "/media/videos/godfather.mp4",
        description:
            "Descriptive text. Movie title, genre story synopsis, etc...",
    },
    {
        id: "breaking-bad",
        title: "Breaking Bad",
        label: "Series",
        meta: "TV Greats",
        genre: "Docuseries",
        phoneArt: "/media/videos/breakingbad-phone.webp",
        thumb: "/media/videos/breakingbad-thumb.png",
        src: "/media/videos/breakingbad.mp4",
        description:
            "Descriptive text. Movie title, genre story synopsis, etc...",
    },
    {
        id: "swingers",
        title: "Swingers",
        label: "Movies",
        meta: "Movie Greats",
        genre: "Comedy · Drama",
        phoneArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/46e994aa8cd94ef3_Screenshot%202026-10-16%20at%202.46.36%E2%80%AFPM.webp",
        thumb: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/aa8adaf2be8d3289_Swingers_Thumbnail.png",
        src: "streamable://hk968z",
        description:
            "Descriptive text. Movie title, genre story synopsis, etc...",
    },
    {
        id: "backrooms",
        title: "Backrooms",
        label: "Movies",
        meta: "Movie Greats",
        genre: "Horror · Mystery",
        phoneArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/20ddbd95fccbd0ae_Screenshot%202026-10-16%20at%203.00.52%E2%80%AFPM.webp",
        thumb: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/6a2c36c25b51dd84_BackRooms_Thumbnail.png",
        src: "streamable://1ml8im",
        description:
            "Descriptive text. Movie title, genre story synopsis, etc...",
    },
];

// Mobile audio phone — mirrors PHONE_MOVIES: artistImage is the idle phone
// art, playingArt fades in while the song plays, cover is the rail
// thumbnail, src is the song's audio file.
export const PHONE_TRACKS = [
    {
        id: "hannah-baby",
        title: "The Hour...that changed the world",
        artist: "Modiphyde",
        meta: "SINGLE",
        artistImage: "/media/modiphyde-artist-hero3.webp",
        playingArt: "/media/modiphyde-fullscreen3.webp",
        cover: "/media/modiphyde-thumb.jpg",
        src: "/media/hannah-baby.mp3",
    },
    {
        id: "aerial",
        title: "Aerial",
        artist: "Chris Whitley",
        meta: "SINGLE",
        artistImage: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/0373d7fa3ee7feb8_Chris%20Whitley%20Hero.webp",
        playingArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/ca9a72f3df1f95d1_Chris%20Whitley%20Audio%20player%20Pic.webp",
        cover: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/a72bf74371c029cf_Chris%20Whitley%20Thumbnail.png",
        src: "/media/audio/aerial.mp3",
    },
    {
        id: "give-you-blue",
        title: "Give you Blue",
        artist: "Allen Stone",
        meta: "SINGLE",
        artistImage: "/media/audio/allenstone-artist.webp",
        playingArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/6bdb40e9fd3b4bb5_Screenshot%202026-10-13%20at%204.07.34%E2%80%AFAM.webp",
        cover: "/media/audio/giveyoublue-cover.jpg",
        src: "/media/audio/give-you-blue.mp3",
    },
    {
        id: "lover-you-should-have-come-over",
        title: "Lover, You should have come over",
        artist: "Joey Landreth",
        meta: "SINGLE",
        artistImage: "/media/audio/joey-artist.webp",
        playingArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/d94a91d7d9d2e26f_Screenshot%202026-10-13%20at%203.30.49%E2%80%AFAM.webp",
        cover: "/media/audio/lover-cover.jpg",
        src: "/media/audio/lover-you-should-have-come-over.mp3",
    },
    {
        id: "here-for-you",
        title: "Here for You",
        artist: "The Great Wide Divide",
        meta: "SINGLE",
        artistImage: "/media/audio/divide-artist.webp",
        playingArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/17d678f194205c03_Screenshot%202026-10-13%20at%203.46.19%E2%80%AFAM.webp",
        cover: "/media/audio/hereforyou-cover.webp",
        src: "/media/audio/here-for-you.mp3",
    },
    {
        id: "pretend",
        title: "Pretend",
        artist: "Roxferry",
        meta: "SINGLE",
        artistImage: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/4c93a48e6a4a6b3b_Roxferry%20Hero%20pic.webp",
        playingArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/b1a53d7b059392f0_Roxferry%20Audio%20player%20pic.webp",
        cover: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/73149f607b7f74c0_Roxferry%20Thumnail.png",
        src: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/e7dcc1064ba53b8c_Roxferry%20-%20PRETEND%20%28official%20video%29.mp3",
    },
    {
        id: "machines-and-magnets",
        title: "Machines & Magnets",
        artist: "Zeroes",
        meta: "SINGLE",
        artistImage: "/media/audio/zeroes-artist.webp",
        playingArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/6d16bb75aa4713a4_Screenshot%202026-10-13%20at%204.11.37%E2%80%AFAM.webp",
        cover: "/media/audio/zeroes-cover.png",
        src: "/media/audio/machines-and-magnets.mp3",
    },
    {
        id: "through-the-smoke",
        title: "Through the Smoke We See Each Other",
        artist: "Sova",
        meta: "SINGLE",
        artistImage: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/9682b0cc844d79fc_Sova_Hero.webp",
        playingArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/ee0e322263dd5a17_Sova_Audio%20player.2png.webp",
        cover: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/535be9b91476a7d9_Sova%20Album%20Thumnailpic2.jpg",
        src: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/a485e83636c467cc_Through%20the%20Smoke%20We%20See%20Each%20Other%20%20Sova.mp3",
    },
    {
        id: "cinema-paradiso",
        hidden: true,
        title: "Cinema Paradiso",
        artist: "Hannah Magnelli",
        meta: "SINGLE",
        artistImage: "/media/audio/magnelli-artist.webp",
        playingArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/b7a9dd9dcbd1e269_Cinema%20Paradiso%20Audio%20Player.webp",
        cover: "/media/audio/cinemaparadiso-cover.png",
        src: "/media/audio/cinema-paradiso.mp3",
    },
    {
        id: "ijustdontknow",
        title: "I just don't know",
        artist: "Corto.Alto",
        meta: "SINGLE",
        artistImage: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/fbfc49b202cc4bc7_CortoAlto%20Hero.webp",
        playingArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/3c0d43a6da9dcff5_CortoAlto%20Audio%20Player.webp",
        cover: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/010688d50ecbd6c2_CortoAltoThumb.png",
        src: "/media/audio/ijustdontknow.mp3",
    },
    {
        id: "no-way-out",
        title: "No Way Out",
        artist: "Ariel Posen",
        meta: "Bannatyne",
        artistImage: "/media/audio/ariel-artist.webp",
        playingArt: "https://customer-assets-jai6qajn.emergentagent.net/job_d7c1dec5-310f-434a-bd74-1db6b13205c7/artifacts/9ec9be4cd8b4742b_Screenshot%202026-10-13%20at%202.30.35%E2%80%AFAM.webp",
        cover: "/media/audio/no-way-out-cover.jpg",
        src: "/media/audio/no-way-out.mp3",
    },
].filter((t) => !t.hidden);

export const VIDEOS = [
    {
        id: "behind-the-beards",
        title: "Behind the Beards and Bikes",
        meta: "RIVVR ORIGINALS",
        poster: "/media/behind-the-beards-poster.jpg",
        src: "/media/behind-the-beards.mp4",
    },
    {
        id: "raiders-lost-ark",
        title: "Raiders of the Lost Ark",
        meta: "Movie Greats",
        poster: "/media/raiders-lost-ark-poster.jpg",
        src: "/media/raiders-lost-ark.mp4",
    },
];

export const trackSlug = (t) =>
    t.title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");

export const slugToIndex = (slug) =>
    slug ? TRACKS.findIndex((t) => trackSlug(t) === slug) : -1;

export const trackUrl = (t) =>
    `${window.location.origin}${window.location.pathname}?track=${trackSlug(t)}`;
